import { render, staticRenderFns } from "./MobileTabItem.vue?vue&type=template&id=118467ae"
import script from "./MobileTabItem.vue?vue&type=script&lang=js"
export * from "./MobileTabItem.vue?vue&type=script&lang=js"
import style0 from "./MobileTabItem.vue?vue&type=style&index=0&id=118467ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports